.react-joyride__tooltip {
  margin: 0px !important;
  padding: 0px !important;
}
// .__floater__arrow {
//     display: none;
// }
